import { loadPlushTextures } from "../bricks/plush";
import { waitForPeerJs } from "../net/Net";

/** Load plush maps, then a tiny splash so the title pops. */
export async function boot(): Promise<void> {
  const fill = document.getElementById("boot-fill");
  const bootEl = document.getElementById("boot");
  if (fill) fill.style.width = "40%";
  await Promise.all([loadPlushTextures(), waitForPeerJs()]);
  if (fill) fill.style.width = "100%";
  await new Promise((r) => window.setTimeout(r, 60));
  bootEl?.classList.add("hidden");
}
